export class CreateIdpGroupRequest {
    'idpId';
    'providerGroupId';
    'roleIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idpId",
            "baseName": "idpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerGroupId",
            "baseName": "providerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleIds",
            "baseName": "roleIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return CreateIdpGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
